export default function () {
    // Ugly Hack: hide headline of "related news"-plugin if there are no related news
    const $noRelatedNews = $('#no-related-news');

    if (!$noRelatedNews.length) {
        return;
    }

    $noRelatedNews.parents('.frame-list-type-news_pi1').hide();
}
